import { useState, useEffect } from "react";

const useInputCheckout = (validationFn, initialValue = "") => {
  const [data, setData] = useState(initialValue);
  const [error, setError] = useState();

  useEffect(() => {
    if (data) {
      //Nếu input có dữ liệu ta xác thực dữ liệu
      if (validationFn(data)) {
        //xác thực là true thì set không có lỗi
        setError();
      } else {
        setError(true);
      }
    } else {
      //Nếu input không có dữ liệu ta sẽ không cho hiển thị thông báo lỗi
      setError();
    }
  }, [data]);
  return { data, setData, error };
};

export default useInputCheckout;
